import { map, share } from 'rxjs/operators';
import { LocalStorageDataStream, messaging } from '@pendo/services/Communication';
import { useThemesStore } from '@/stores/themes.store';
import { useLayoutsStore } from '@/stores/layouts.store';

const { messageChannels, messageType } = messaging;

export function createAppEngineMessage$ () {
    const localStorageDataStream = new LocalStorageDataStream('localStorage', 'pendo', { listen: false });
    localStorageDataStream.listen();

    return localStorageDataStream.getMessagesForChannel$(messageChannels.APPENGINE).pipe(
        map((envelope) => envelope.message),
        share(),
    );
}

export function listenToDesigner (_store) {
    createAppEngineMessage$().subscribe((message) => {
        if (message.type === messageType.RELOAD_LAYOUTS) {
            useLayoutsStore().loadAll({ reFetch: true });
        } else if (message.type === messageType.RELOAD_THEMES) {
            useThemesStore().loadAll({ reFetch: true });
        }
    });
}
